var map = {
	"./de.json": 105,
	"./en.json": 106,
	"./fr.json": 107,
	"./ja.json": 108,
	"./ko.json": 109,
	"./pt-br.json": 110,
	"./ru.json": 111,
	"./zh.json": 112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 104;